<div class="grid grid-cols-1 md:grid-cols-2 gap-6">
  <div>
    <label
      class="block text-sm text-gray-700 mb-2"
      [appTranslateKey]="[languageKey.PRIORITY_COLOR]"
    ></label>
    <div class="color-picker-container">
      <p-selectButton
        [options]="colors()"
        [(ngModel)]="selectedColor"
        (onChange)="onSelect($event)"
        optionLabel="hex"
        dataKey="hex"
        [multiple]="false"
      >
        <ng-template pTemplate="item" let-item>
          <span
            class="color-circle"
            [style.backgroundColor]="item.hex"
            [pTooltip]="item.hex"
          ></span>
        </ng-template>
      </p-selectButton>
    </div>
  </div>

  <div *ngIf="buttonName?.length > 0">
    <label
      class="block text-sm text-gray-700 mb-2"
      [appTranslateKey]="[languageKey.PREVIEW_BUTTON_TOTEM]"
    ></label>
    <div
      class="bg-gray-50 rounded-lg p-4 border border-gray-200 flex items-center justify-center"
      style="min-height: 100px"
    >
      <button
        type="button"
        [style.backgroundColor]="selectedColor()?.hex"
        class="px-6 py-3 rounded-lg text-white transition-all shadow-md hover:shadow-lg break-all"
      >
        {{ buttonName }}
      </button>
    </div>
  </div>
</div>
